import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Pagination]);

var formSwipper;

//IE Special
var ua = window.navigator.userAgent;
var msie = ua.indexOf("MSIE ");
if($('summary').length>0 || $('.form-main-first').length>0) {
    // If Internet Explorer, return version number
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  {
        $('.swiper-button-prev').append('<i class="fas fa-chevron-left"></i>');
        $('.swiper-button-next').append('<i class="fas fa-chevron-right"></i>');
    }
}


export function reloadCarousel() { 
    formSwipper = new Swiper('.swiper-form', {
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 5,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            380: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                slidesPerColumn: 1,
                spaceBetween: 2,
                slidesPerColumnFill: 'row',
            },
            400: {
                slidesPerView: 2,
                spaceBetween: 2,
            },
            640: {
                slidesPerView: 2,
                spaceBetween: 4,
            },
            810: {
                slidesPerView: 4,
                spaceBetween: 5,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 5,
            }, 
            1200: {
                slidesPerView: 4,
                spaceBetween: 5,
            }, 
        }
    })
}